<template>
  <div class="col-12">
    <div class="row align-items-center mt-3" v-if="type === 'single'">
      <div class="col-12 font-bold mb-4">
        <h5 class="card-title">Welches Angebot betreiben Sie in erster Linie?</h5>
      </div>
      <ErrorMessage name="freizeitanbieter" class="font-bold my-2"/>
      <Field type="radio" name="freizeitanbieter" v-model="surveyStore.data.freizeitanbieter" >
        <div class="col-12 col-lg-6" :key="option.key" v-for="option in surveyStore.currentConfig.currentStep.freizeitanbieter.radios">
          <div class="form-check">
            <input type="radio" name="freizeitanbieter" :id="option.key" :value="option.key" class="form-check-input"
                   v-model="surveyStore.data.freizeitanbieter" :class="{'is-invalid': errors.freizeitanbieter}"/>
            <label class="form-check-label" :for="option.key">
              {{ option.label }}
            </label>
          </div>
        </div>
      </Field>
    </div>
    <div class="row align-items-center mt-3" v-else>
      <div class="col-12 font-bold mb-4">
        Bieten Sie auch Verpflegung oder weitere Freizeitaktivitäten an?
      </div>
      <div class="col-12 col-lg-6" :key="option.key" v-for="option in surveyStore.currentConfig.currentStep.freizeitanbieter_weitere.checkboxes">
        <div class="form-check">
          <Field type="checkbox" :name="option.key">
            <input type="checkbox" :name="option.key" :id="option.key" :value="option.key" class="form-check-input"
                   v-model="surveyStore.data.freizeitanbieter_weitere"/>
            <label class="form-check-label" :for="option.key">
              {{ option.label }}
            </label>
          </Field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "@/stores/survey";
import {Field, ErrorMessage} from 'vee-validate';

export default {
  components: {
    Field,
    ErrorMessage
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {
    }
  },
  props: {
    errors: Object,
    type: {
      type: String,
      default: 'single'
    }
  },
  methods: {},

}
</script>
